import {appState} from "../app.state";

export class NavigationHelper {

    public static goto(pathName: string): void {
        history.pushState({}, '', pathName);
        appState.router.goto(pathName);
    }
}